<template>
  <el-header height="80px" class="header test">
    <el-col class="header-left" :sm="12" :md="12" :lg="12" :xl="16">
      <!-- 隐藏 -->
      <!-- <el-button class="collapse-icon header-icon" v-model="isCollapse" :icon="isCollapse?'el-icon-s-fold':'el-icon-s-unfold'" @click="collapseClick"></el-button> -->

      <!-- 旧版页面切换功能，结合vuex -->
      <!-- <el-tabs class="header-tabs" v-model="currentHeadTab" type="card" closable @tab-remove="removeTab" @tab-click="currentTab">
        <el-tab-pane class="header-tabs-con" v-for="(item) in headTabs" :key="item.title" :label="item.title" :name="item.addNum"></el-tab-pane>
      </el-tabs> -->
      <!-- 新版换成面包屑 -->
      <div class="bread-route df pl-20">
        <div v-for="(v,k) in breadRoute" :key="k" class="bread-route-item">
          <span @click="turnView(v)" class="csp">{{v.title}}</span>
          <i class="el-icon-arrow-right t14"></i>
        </div>
      </div>

      <el-button v-show="headTabs.length>1" class="header-btn-clear" @click="clearTab" v-if="false">清空</el-button>
    </el-col>
    <el-input class="share-link-input-copy2" v-model="sellerInfo.url" readonly style="opacity: 0"></el-input>

    <el-col class="header-right" :sm="12" :md="12" :lg="12" :xl="8">

      <!-- 隐藏 -->
      <el-carousel class="header-swiper" height="40px" direction="vertical" :autoplay="true" v-if="false">
        <el-carousel-item v-for="(item, index) in ads" :key="index">
          <p class="medium">
            <i :class="item.icon"></i>
            {{ item.content }}
          </p>
        </el-carousel-item>
      </el-carousel>

      <!-- 店铺下拉选择 -->
      <el-select
        v-model="currentStore"
        size="small"
        class="header-store-select"
        placeholder="选择店铺"
        @change="handleStoreChange"
      >
        <el-option
          v-for="item in accountList"
          :key="item.id"
          :label="item.seller_name"
          :value="String(item.id)"
        />
      </el-select>

      <div class="header-user-actions">
        <el-button
          class="header-action-btn"
          size="small"
          @click="goUserSetting"
        >设置</el-button>
        <el-button
          class="header-action-btn"
          size="small"
          @click="exit"
        >退出</el-button>
      </div>
      <!-- v-if="false"隐藏 -->
      <el-badge class="header-msg-badge" :max="99" v-if="false">
        <el-button class="header-icon header-icon-msg" icon="iconfont icon-lingdang" @click="notice"></el-button>
      </el-badge>
      <el-button class="header-icon header-icon-exit" icon="iconfont icon-caozuo-tuichu" @click="exit" v-if="false"></el-button>
    </el-col>
  </el-header>
</template>

<script>
import index from "@/views/index.vue";
export default {
  data () {
    return {
      // isCollapse: false,
      ads: [
        {
          icon: "iconfont icon-tongzhi",
          content: "欢迎使用八块钱网商家后台管理系统！"
        },
        {
          icon: "iconfont icon-tongzhi",
          content: "欢迎使用八块钱网商家后台管理系统！"
        },
        {
          icon: "iconfont icon-tongzhi",
          content: "欢迎使用八块钱网商家后台管理系统！"
        }
      ],
      user: {},
      sellerInfo:{},
      accountList: [],
      currentStore: "",
    };
  },
  created () {
    // console.log(JSON.parse(sessionStorage.getItem("headTabs")));
    // console.log(JSON.parse(sessionStorage.getItem("currentHeadTab")));
    //获取本地保存用户信息
    this.user.id = localStorage.getItem("uid");
    this.user.name = localStorage.getItem("name");
    this.user.avatar = this.$url(localStorage.getItem("avatar"));
    try {
      this.accountList = JSON.parse(localStorage.getItem("account_list")) || [];
    } catch (error) {
      this.accountList = [];
    }
    this.currentStore = String(
      this.user.id ||
        (this.accountList[0] && this.accountList[0].id) ||
        ""
    );
    // document.body.clientWidth < 1300
    //   ? (this.isCollapse = true)
    //   : (this.isCollapse = false);
  },
  mounted () {
    sessionStorage.setItem('lastClick', '首页')
  },
  computed: {
    breadRoute: {
      get: function () {
        return this.$store.state.breadroute;
      },
      // 这个set是干嘛的？为什么可以要直接改变state的值？配合elementUI？
      set: function (newVal) {
        this.$store.state.breadroute = newVal;
      }
    },
    headTabs: {
      get: function () {
        // if (JSON.parse(sessionStorage.getItem("currentHeadTab")) != 1) {
        //   return JSON.parse(sessionStorage.getItem("headTabs"));
        // } else {
        return this.$store.state.headTabs;
        // }
      },
      set: function (newVal) {
        this.$store.state.headTabs = newVal;
      }
    },
    currentHeadTab: {
      get: function () {
        // if (JSON.parse(sessionStorage.getItem("currentHeadTab")) != 1) {
        //   return JSON.parse(sessionStorage.getItem("currentHeadTab"));
        // } else {
        return this.$store.state.currentHeadTab;
        // }
      },
      set: function (newVal) {
        this.$store.state.headTabsValue = newVal;
      }
    }
  },
  watch: {
    "$store.state.sellerInfo":{
       handler:function(newVal,oldVal){
          this.sellerInfo = newVal;  
       }
     }
    // isCollapse () {
    //   this.$emit("collapseFn", this.isCollapse);
    // }
  },
  methods: {
    turnView(v){
      let crn = this.$store.getters.getCurrentTab
      let title = v.title
      let url = v.url || v.uri
      if(title && url && (crn.title !== title || crn.url !== url)){
        this.$store.dispatch("addHeadTab", {
          addTitle: title,
          addUrl: url
        });
      }
    },
    errorHandler(){
      return true
    },
    // collapseClick () {
    //   this.isCollapse = !this.isCollapse;
    // },
    currentTab (currentIndex) {
      this.$store.dispatch("setCurrentHeadTab", currentIndex);
    },
    removeTab (index) {
      this.$store.dispatch("removeHeadTabo", index);
    },
    copyUrl(){
      var ele=document.querySelector('.share-link-input-copy2 input');
      // 选择对象  
      ele.select(); 
      // 执行浏览器复制命令
      var ss = document.execCommand("Copy"); 
      if (ss) {
        this.$popup('复制成功', 'success');
      }
    },
    notice () { },
    exit () {
      this.$confirm("确定退出账号吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios
          .post("/api/v1/admin/logout", {})
          .then(res => {
            if (res.data.status == "200") {

              this.$popup("退出成功!", "success");
              sessionStorage.removeItem("login");
              setTimeout(() => {
                this.$router.push({
                  path: "/login"
                });
              }, 1000);
            } else {

              this.$popup(res.data.msg, "error");
            }
          })
          .catch(error => {
            this.$popup(error, "error");
          });
      })
        .catch(() => { });
    },
    goUserSetting () {
      this.$store.dispatch("addHeadTab", {
        addTitle: "个人设置",
        addUrl: "userSetting"
      });
    },
    clearTab () {
      this.$store.dispatch("setHeadTabs", [
        {
          title: "首页",
          addNum: "1",
          content: "index",
          close: false
        }
      ]);
    },
    goLogs () {
      this.$store.dispatch("addHeadTab", {
        addTitle: "操作日志",
        addUrl: "operationLogs"
      });
    },
    handleStoreChange (value) {
      const storeId = Number(value)
      this.$axios
        .post("/api/v1/admin/switchSeller", {
          id: storeId
        })
        .then(res => {
          if (res.data && res.data.status == "200") {
            localStorage.setItem("uid", res.data.data.admin.id);
            localStorage.setItem("name", res.data.data.admin.nickname);
            localStorage.setItem("avatar", res.data.data.admin.avatar);
            localStorage.setItem("account_list", JSON.stringify(res.data.data.admin.account_list));
            this.$popup("店铺切换成功!", "success");
            setTimeout(() => {
              window.location.reload();
            }, 500);
          } else {
            this.$popup((res.data && res.data.msg) || "店铺切换失败", "error");
          }
        })
        .catch(error => {
          this.$popup(error, "error");
        });
    }
  }
};
</script>

<style lang="less">
@HEADER_HIGHT: 80px;
@HEADER_INNER: 40px;
.seller-header-icon{
    width: 22px;
    height: 21px;
    display: inline-block;
    background: url(../../assets/images/seller_header.png) no-repeat;
    background-size: 100% 100%;
    margin-right: 8px;
}
.header {
  width: 100%;
  min-width: 1200px;
  height: @HEADER_HIGHT !important;
  padding: 20px !important;
  box-sizing: border-box;
  font-size: 13px;
  color: #081234;
  z-index: 2000;
  background-color: inherit;
  display: flex;
  text-align: left;
  .el-dropdown-menu .el-popper {
    width: 11px;
    .el-dropdown-menu__item {
      line-height: 33px;
    }
  }
  .header-left {
    display: flex;
    height: @HEADER_INNER;
    justify-content: flex-start;
    align-items: center;
    // 面包屑导航
    .bread-route {
      color: @WARMBOR;
      .bread-route-item {
        font-size: 15px;
        i {
          margin-right: 4px;
        }
        &:last-of-type {
          span{
            color: @SAASFONTCOLOR;
          }
          i {
            display: none;
            margin-right: 4px;
          }
        }
      }
    }
    .el-tabs--top {
      display: inline-block;
      vertical-align: top;
      width: 70%;
      .el-tabs__nav-next,
      .el-tabs__nav-prev {
        line-height: 37px !important;
      }
    }
    .header-btn-clear {
      // position: relative;
      // top: 3px;
      color: #2e71fe;
      border: none;
      background: transparent;
      &:hover {
        color: #2e71fe;
        background: transparent;
      }
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item {
      min-width: 106px;
      height: @HEADER_INNER;
      border-radius: 18px;
      text-align: center;
      line-height: @HEADER_INNER;
      background-color: #ffffff;
      user-select: none;
      &:hover {
        color: #2e71fe;
      }
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
      background-color: #2e71fe;
      color: #ffffff !important;
    }
    .el-tabs__header .el-tabs__item:first-child span {
      display: none;
    }
    .el-tabs--card > .el-tabs__header,
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border: none;
    }
    // .header-tabs {
    //   // flex: 1;
    // }
    .header-tabs-con {
      display: none;
    }
  }
  .header-right {
    display: flex;
    height: @HEADER_INNER;
    justify-content: flex-end;
    .el-avatar {
      background: none !important;
    }
  }
  .el-button {
    margin-right: 20px;
    margin-left: 0;
  }
  .el-button--primary {
    width: 106px;
    height: @HEADER_INNER;
    line-height: 12px;
    background: #2e71fe;
  }
  .header-msg-badge {
    width: @HEADER_INNER;
    height: @HEADER_INNER;
    margin-right: 20px;
  }
  .header-icon {
    width: @HEADER_INNER;
    height: @HEADER_INNER;
    flex-shrink: 0;
    border-radius: 50%;
    padding: 0;
    border: none;
    font-size: 18px;
    font-weight: bold;
    color: #081234;
  }
  .header-icon-exit {
    margin-right: 0;
  }
  .el-button:focus,
  .el-button:hover {
    color: #606266;
    border-color: #ffffff;
    background: #ffffff;
  }
}
.header-store-select {
  min-width: 180px;
  width: auto;
  margin-right: 20px;
  .el-input__inner {
    height: @HEADER_INNER;
    line-height: @HEADER_INNER;
    border-radius: 18px;
    border: none;
    background: #ffffff;
    padding: 0 30px 0 16px;
    font-size: 13px;
    color: #081234;
  }
  .el-input__suffix {
    right: 10px;
  }
}
.header-user-actions {
  display: flex;
  align-items: center;
  .header-action-btn {
    border-radius: 18px;
    border: none;
    background: #ffffff;
    color: #081234;
    padding: 0 18px;
    height: @HEADER_INNER;
    line-height: @HEADER_INNER;
    margin-right: 12px;
    &:last-child {
      margin-right: 0;
    }
  }
  .header-action-btn:hover {
    color: #2e71fe;
    background: #f3f6ff;
  }
}
.header-swiper {
  width: 330px;
  height: @HEADER_INNER;
  background: #ffffff;
  border-radius: 18px;
  margin-right: 20px;
  padding: 0 16px;
  box-sizing: border-box;
  .el-carousel__item p {
    margin: 0;
    line-height: @HEADER_INNER;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    i {
      margin-right: 8px;
    }
  }
}
.header-seller-store{
  height: @HEADER_INNER;
  line-height: @HEADER_INNER;
  margin-right: 32px;
  .header-seller-span{
      color:#FF3A3A;
      font-size: 14px;
      display: flex;
      align-items: center;
  }
}
.header-seller-dropdown{
  width: 400px;
  height: 312px;
  box-sizing: border-box;
  padding: 40px;
  .share-main {
    text-align: center;
    .el-input.is-disabled .el-input__inner {
      background: #e5e5e5;
    }
    .copy-btn {
      width: 100px;
      margin-left: 20px;
    }
  }
   .share-link-input {
    width: 200px;
  }
    div .el-button--default.el-button:hover {
      color: #fff;
      background: #ff3a3a;
      border: none;
    
    }
    .el-dropdown-menu__item:not(.is-disabled):hover{
      background: none;
    }
  .cre-activity-btn {
      background: #ff3a3a;
      box-shadow: 0px 6px 11px -5px rgba(255, 82, 82, 1);
      color: #fff;
      border-radius: 5px;
      width: 100px;
      height: 42px;
      padding: unset;
      border: none;
    }
  .qrcode {
    width: 160px;
    height: 160px;
  }
}
.header-user {
  height: @HEADER_INNER;
  background: transparent;
  border-radius: 18px;
  margin-right: 20px;
  .el-dropdown-selfdefine:focus {
    outline: none;
  }
  .user-info {
    min-width: 110px;
    position: relative;
    padding-right: 24px;
    height: @HEADER_INNER;

    .user-name {
      display: inline-block;
      max-width: 69px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: top;
      line-height: @HEADER_INNER;
      color: #081234;
    }
    .el-avatar {
      width: @HEADER_INNER;
      height: @HEADER_INNER;
      margin-right: 8px;
      border: 2px solid #fff;
      box-shadow: 0px 0px 5px #000;
      box-sizing: content-box;
    }
    .el-icon-arrow-down {
      &:before {
        content: "\E790" !important;
        color: #081234;
      }
      position: absolute;
      top: 0;
      right: 8px;
      display: inline-block;
      vertical-align: top;
      line-height: @HEADER_INNER;
      transition: all 0.3s ease;
    }
  }
}
.header-user-dropdown {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header.vue